export default __webpack_public_path__ + "static/media/arrow_right.e626bef2.svg";